module.exports = __webpack_public_path__ + "static/img/icon-02.06a0b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/icon-02.png
// module id = iH7C
// module chunks = 1